const QUANTIDADE_DE_DIGITOS_DO_CNPJ = 14;

function calcularDigitoVerificador(digitos) {
  let peso = digitos.length - 7;
  let soma = 0;

  digitos.forEach((digito) => {
    soma += digito * peso;
    peso = peso - 1 < 2 ? 9 : peso - 1;
  });

  const resto = soma % 11;

  return resto < 2 ? 0 : 11 - resto;
}

export default function validarCnpj(cnpj) {
  const digitos = String(cnpj || '').replace(/\D/g, '');

  if (digitos.length !== QUANTIDADE_DE_DIGITOS_DO_CNPJ) return false;

  if (/^(\d)\1+$/.test(digitos)) return false;

  const numeros = digitos.split('').map(Number);
  const primeiroDigitoVerificador = calcularDigitoVerificador(numeros.slice(0, 12));
  const segundoDigitoVerificador = calcularDigitoVerificador(numeros.slice(0, 13));

  return primeiroDigitoVerificador === numeros[12] && segundoDigitoVerificador === numeros[13];
}



// WEBPACK FOOTER //
// ./src/utils/validadorDeCnpj.js